let nextIdValue = 1;
let hasContainer = false;
let defaultOutDelay = 0;

let modalSets = {};

let setHandlers = {};
let setIdsHandler = () => { };

export function resetAll() {
  modalSets = {};
  setHandlers = {};
  defaultOutDelay = 0;
}

export function setDefaultOutDelay(outDelay) {
  defaultOutDelay = outDelay;
}

export function setModalSetIdsHandler(handler) {
  hasContainer = true;
  setIdsHandler = handler;
  handler(getSetIds());
}

export function clearModalSetIdsHandler() {
  setIdsHandler = () => { };
}

export function setModalSetHandler(id, handler) {
  hasContainer = true;
  setHandlers[id] = handler;
  handler(modalSets[id] || []);
}

export function clearModalSetHandler(id) {
  delete setHandlers[id];
}

export function mountModal(info) {
  if (firstMount() && !hasContainer) {
    setTimeout(warnIfNoContainer, 1000);
  }

  const id = nextId();

  info = Object.assign({ setId: 0 }, info);
  if (typeof info.outDelay === 'undefined') info.outDelay = defaultOutDelay;
  const setId = info.setId;

  let notifySetIds = false;
  if (!modalSets[setId]) {
    modalSets[setId] = [];
    notifySetIds = true;
  }

  modalSets[setId].push({ id, info, setId });
  modalSets[setId].sort(compareModals);

  if (notifySetIds) {
    setIdsHandler(getSetIds());
  }

  if (setHandlers[setId]) {
    setHandlers[setId](modalSets[setId]);
  }

  return id;
}


export function updateModal(id, info) {
  const setIds = getSetIds();
  let foundSetId;
  setIds.forEach(setId => {
    modalSets[setId] = modalSets[setId].map(modal => {
      if (modal.id === id) {
        foundSetId = setId;
        return { id, info };
      }
      return modal;
    });
  });

  if (typeof foundSetId === 'undefined') {
    console.log('react-router-modal: updateModal with bad id', id); //eslint-disable-line
  }
  else {
    const handler = setHandlers[foundSetId];
    if (handler) handler(modalSets[foundSetId]);
  }
}

export function containerCreated(id, container) {
  const modal = findModalById(id);
  if (!modal) return;
  modal.container = container;
  modal.onPortalDestination(container);
}

export function unmountModal(id) {
  const modal = findModalById(id);

  if (!modal) return Promise.resolve();

  if (modal.outDelay) {
    if (modal.container) {
      modal.frozenContent = modal.container.innerHTML;
    }
    const updated = {...modal, out: true};

    updateModal(id, updated);
    return new Promise(resolve => {
      setTimeout(() => {
        removeModal(id)
        resolve();
      }, modal.outDelay);
    });
  }
  else {
    removeModal(id);
    return Promise.resolve();
  }
}

function getSetIds() {
  return Object.keys(modalSets).map(id => parseInt(id, 10));
}

function compareModals(a, b) {
  const stackOrderDiff = (a.info.stackOrder || 0) - (b.info.stackOrder || 0);
  if (stackOrderDiff !== 0) return stackOrderDiff;
  return a.id - b.id;
}

function findModalById(id) {
  const setIds = getSetIds();
  for(let i = 0; i < setIds.length; i++) {
    let modals = modalSets[setIds[i]];
    for(let j = 0; j < modals.length; j++) {
      if (modals[j].id === id) return modals[j].info;
    }
  }
}

function removeModal(id) {
  const setIds = getSetIds();
  let foundSetId;
  setIds.forEach(setId => {
    modalSets[setId] = modalSets[setId].filter(modal => {
      if (modal.id === id) {
        foundSetId = setId;
        return false
      }
      return true;
    });
  });

  if (typeof foundSetId !== 'undefined') {
    if (modalSets[foundSetId].length === 0) {
      delete modalSets[foundSetId];
    }
    setIdsHandler(getSetIds());
    const handler = setHandlers[foundSetId];
    if (handler) handler(modalSets[foundSetId] || []);
  }
}

function firstMount() {
  return nextIdValue === 0;
}

function nextId() {
  return nextIdValue++;
}

function warnIfNoContainer() {
  if (!hasContainer) {
    console.log(`react-router-modal warning: Modal was mounted but no <ModalContainer /> found`); //eslint-disable-line
  }
}
